module.exports = __webpack_public_path__ + "static/img/qingyiweixin.13b4e55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingyiweixin.jpg
// module id = r+O0
// module chunks = 19